import React, { FC } from 'react';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import { Box } from '@material-ui/core';
import cx from 'classnames';

import { translate } from '../../../../utils/helpers';
import { USER_ROLES, LearnerInfo } from '../../../../types';
import { USER_ROLES_NAMES } from '../SingleTeamView/const';
import TableRowWithActions from '../../../../components/UI/TableRowWithActions';
import { LightTooltip } from '../../../../components/UI/LightTooltip';
import useStyles from './styles';

interface SingleTeamTableRowProps {
  member: LearnerInfo;
  isOwner: boolean;
  onChangeTeam: (member: LearnerInfo) => void;
  onChangeRole: () => void;
  onRemoveUser: (member: LearnerInfo) => void;
}

const SingleTeamTableRow: FC<SingleTeamTableRowProps> = ({
  member,
  isOwner,
  onChangeTeam,
  onChangeRole,
  onRemoveUser,
}) => {
  const classes = useStyles();

  const memberRole =
    member.role === USER_ROLES.TeamManager
      ? 'page.account.setAslearner'
      : 'page.account.setAsManager';

  const memberLogin = member?.last_login
    ? parse(member?.last_login, 'yyyy-MM-dd HH:mm:ss', new Date())
    : new Date();
  const lastLogin = formatDistanceToNow(memberLogin);
  const formattedDate = format(memberLogin, 'HH:mm E, do MMM yyyy');
  const role = USER_ROLES_NAMES[member.role || ''];
  const isMemberOwner = member.role === USER_ROLES.CompanyOwner;

  const actionsList =
    isOwner && !isMemberOwner ? (
      <>
        <li onClick={() => onChangeTeam(member)}>{translate('page.account.changeTeam')}</li>
        <li onClick={onChangeRole}>{translate(memberRole)}</li>
        <li onClick={() => onRemoveUser(member)}>{translate('page.account.removeFromOrg')}</li>
      </>
    ) : undefined;

  return (
    <TableRowWithActions actionsList={actionsList}>
      <>
        <Box className={cx(classes.learnerCell, classes.tableCell)}>
          <div className={classes.learnerName}>{member?.name}</div>
          <div className={classes.learnerRoleMobile}>{translate(`page.account.${role}`)}</div>
          <div className={classes.learnerEmail}>{member?.email}</div>
        </Box>
        <Box className={cx(classes.tableCell, 'hidden-on-mobile')}>
          {translate(`page.account.${role}`)}
        </Box>
        <Box className={classes.tableCell}>
          <LightTooltip title={formattedDate} placement="top">
            <span>{lastLogin}</span>
          </LightTooltip>
        </Box>
      </>
    </TableRowWithActions>
  );
};

export default SingleTeamTableRow;
